var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "scrollable-sidesheet",
    {
      attrs: { active: _vm.active, title: _vm.title },
      on: { close: _vm.close },
      scopedSlots: _vm._u(
        [
          _vm.reportId
            ? {
                key: "header-actions",
                fn: function () {
                  return [
                    _c("c-button", {
                      attrs: {
                        size: "small",
                        icon: { icon: "trash", color: "secondary" },
                        label: "Удалить",
                      },
                      on: { click: _vm.remove },
                    }),
                  ]
                },
                proxy: true,
              }
            : null,
          {
            key: "actions",
            fn: function () {
              return [
                _c("c-button", {
                  attrs: { size: "large", label: "Отменить" },
                  on: { click: _vm.close },
                }),
                _c("c-button", {
                  attrs: {
                    label: _vm.submitLabel,
                    color: "primary",
                    size: "large",
                    disabled: _vm.pending,
                  },
                  on: { click: _vm.submit },
                }),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _c("m-confirm", { ref: "confirm", attrs: { mode: "danger" } }),
      _vm.loading
        ? _c("c-loader", {
            attrs: {
              active: _vm.loading,
              label: "Данные загружаются",
              height: 300,
            },
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "report",
          style: {
            display: _vm.loading ? "none" : "",
          },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col col-12 col-md-10 col-xl-6" }, [
              _c(
                "div",
                { staticClass: "form-group report__name" },
                [
                  _c("c-input", {
                    class: { "is-invalid": _vm.isSubmitted && _vm.nameError },
                    attrs: {
                      "floating-label": "Наименование отчета",
                      "required-mark": true,
                      clearable: true,
                      "max-length": 255,
                      required: _vm.isSubmitted && _vm.nameError,
                      "required-condition": _vm.isSubmitted && _vm.nameError,
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col col-12 col-md-5 col-xl-3" }, [
              _c(
                "div",
                { staticClass: "form-group report__category" },
                [
                  _c("c-select", {
                    attrs: {
                      type: "select",
                      "floating-label": "Категория",
                      clearable: true,
                      searchable: true,
                      items: _vm.dictionaries.categories,
                    },
                    model: {
                      value: _vm.form.category,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "category", $$v)
                      },
                      expression: "form.category",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "col col-12 col-md-5 col-xl-3" }, [
              _c(
                "div",
                { staticClass: "form-group report__responsible" },
                [
                  _c("c-select", {
                    ref: "responsible",
                    attrs: {
                      type: "select",
                      "floating-label": "Ответственный",
                      clearable: true,
                      searchable: true,
                      items: _vm.dictionaries.workers,
                    },
                    model: {
                      value: _vm.form.responsible,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "responsible", $$v)
                      },
                      expression: "form.responsible",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "form-group report__chat" },
            [
              _c("c-switcher", {
                attrs: { label: "Включить обсуждение" },
                model: {
                  value: _vm.form.chat,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "chat", $$v)
                  },
                  expression: "form.chat",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col col-12 col-md-10 col-xl-9" }, [
              _c(
                "div",
                { staticClass: "form-group report__description" },
                [
                  _c("c-textarea", {
                    ref: "description",
                    staticClass: "description",
                    attrs: {
                      "floating-label": "Описание отчета",
                      clearable: true,
                    },
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "description", $$v)
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "report__files" },
            [
              _c("file-loader", {
                ref: "loader",
                attrs: {
                  limit: 10,
                  format: "all",
                  actions: "loadFiles,preview",
                  links: _vm.form.fileLinks,
                  accept:
                    "jpeg,jpg,gif,png,mp4,avi,wmv,mov,3gp,flv,mpeg-1,mpeg-2,webm",
                },
                on: {
                  changeLinks: function ($event) {
                    _vm.form.fileLinks = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "note",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "note" }, [
                          _vm._v(
                            " Допустимые форматы изображений: .jpeg, .jpg, .gif, .png, видео: .mp4, .avi, .wmv, .mov, .3gp, .flv, .mpeg-1,2, .webm. Размер файла — не более 10Мб. "
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.form.files,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "files", $$v)
                  },
                  expression: "form.files",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }